module.exports = __webpack_public_path__ + "img/1756265571252-image.jpg.07555531.webp";